import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getProfile } from 'redux/actions/SettingsAction';
import store from 'redux/store';
import { GET_PROFILE, GET_UPDATEPROFILE } from 'resources/actionTypes';
import { profileApi, updateProfileApi } from 'services/SettingsService';
import { onLoaderTrigger } from 'redux/actions/commonAction';

function* getProfileListener(action) {
  const payload = action.payload || {};

  if (payload?.payloadType) {
    store.dispatch(onLoaderTrigger(true));
  }

  const userProfile = yield call(profileApi);

  if (userProfile.success) {
    localStorage?.setItem('user', JSON.stringify(userProfile?.data));
    localStorage.setItem('countryCode', userProfile?.data?.countryCode);
    localStorage.setItem('ID', userProfile?.data?.id);
    localStorage.setItem('role', userProfile?.data?.companyType);
    localStorage.setItem('status', userProfile?.data?.status);
    localStorage.setItem('companyId', userProfile?.data?.companyId);
    localStorage.setItem('location', userProfile?.data?.location);
    localStorage.setItem('serviceRegion', userProfile?.data?.serviceRegion);
    localStorage.setItem('companyName', userProfile?.data?.companyName);

    yield put({
      type: GET_PROFILE.GET_PROFILE_SUCCESS,
      userProfile: userProfile,
    });
  } else {
    yield put({
      type: GET_PROFILE.GET_PROFILE_FAILED,
      message: userProfile.message,
    });
    toast.error(userProfile?.message || 'Login failed');
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* getProfileSaga() {
  yield takeEvery(GET_PROFILE.GET_PROFILE_REQUESTED, getProfileListener);
}

function* fetchUpdateProfile(action) {
  const payload = action.payload || {};
  const userUpdateProfile = yield call(
    updateProfileApi,
    payload.userUpdateProfile
  );
  if (userUpdateProfile.success) {
    yield put({
      type: GET_UPDATEPROFILE.GET_UPDATEPROFILE_SUCCESS,
      userUpdateProfile: userUpdateProfile,
    });
    toast.success(userUpdateProfile.message);
    store.dispatch(getProfile());
  } else {
    yield put({
      type: GET_UPDATEPROFILE.GET_UPDATEPROFILE_SUCCESS,
      message: userUpdateProfile.message,
    });
    toast.error(userUpdateProfile?.message || 'Update Profile failed');
  }
}
export function* updateProfileSaga() {
  yield takeEvery(
    GET_UPDATEPROFILE.GET_UPDATEPROFILE_REQUESTED,
    fetchUpdateProfile
  );
}
